import React from "react";
import VariantComponents from "../../ModalDynamicFunctionalTemp/VariantComponents";
import ActualityLogo from "../ActualityLogo";

const MobileBottom = ({ propState, selectMaterial, checkSelected }) => {
  return (
    <div
      style={{
        display: "flex",

        flexDirection: "column",
        alignItems: "center",
        border: "0px solid red",
      }}
    >
      <div
        style={{
          marginTop: "1rem",
          border: "0px solid #ddd",
          width: "100%",
          paddingTop: 0,
          zIndex: 2000,
          scrollbarWidth: "none",
          marginBottom: "0.5rem",
          width: "100vw",
        }}
      >
        <VariantComponents
          variantControllerHeight={125}
          Component={propState.Components}
          selectMateril={selectMaterial}
          checkSelected={checkSelected}
          addClass={true}
        />
      </div>
      <ActualityLogo propState={propState} />
    </div>
  );
};

export default MobileBottom;
